/* globals $ */

;(function() {
    'use strict';

    var _ = require('lodash');
    var POSTS_PER_PAGE = 10;

    var FeedMetrics = function() {
        this.$feedPlaceholder = $('#feed-placeholder');
    };

    FeedMetrics.prototype._hasPostResumo = function($post) {
        return $post.find('.feed-post-body-resumo').text() ? true : false;
    };

    FeedMetrics.prototype._getAbsolutePostPosition = function($post) {
        var $page = $post.parents('.bastian-page');
        var pageNumber = $page.data('page-index');
        var postPosition = $page.children().index($post);
        var finalPostPosition = pageNumber * POSTS_PER_PAGE - POSTS_PER_PAGE + postPosition + 1;

        return finalPostPosition;
    };

    FeedMetrics.prototype._getPostFromEventTarget = function(eventTarget) {
        var $eventTarget = $(eventTarget);
        var $post = $eventTarget.parents('.feed-post');

        return $post;
    };

    // ============================================================
    // ========================== HORIZON =========================
    // ============================================================

    var HorizonFeedMetrics = function(horizonHost, portal) {
        FeedMetrics.call(this);

        this.horizonUrl = horizonHost + '/auth/stream';
        this.product = portal;
        this.data = [];
        this.lastPostViewedPosition = 0;
        this.timeSeenFeed = 0;
        this.countFeedTime = 0;
        this.feedType = $('.bastian').data('feed-type');
        this.windowIsVisible = true;
        this.$feedPosts = $('.feed-post');
        this.$titleFirstPost = this.$feedPosts.eq(0).find('.feed-post-body-title');
        this.$document = $(document);
        this.$window = $(window);
        this.device_group = window.SETTINGS.BASTIAN.DEVICE_GROUP;

        return this;
    };

    HorizonFeedMetrics.prototype = Object.create(FeedMetrics.prototype);
    HorizonFeedMetrics.prototype.constructor = HorizonFeedMetrics;

    HorizonFeedMetrics.prototype.bindEvents = function() {
        var oneSecond = 1000;
        var throttledPostClickMetrics = _.throttle(this._postClickMetrics, oneSecond);
        var throttledPostViewMetrics = _.throttle(this._postViewMetrics, oneSecond);
        var throttledFeedTimeMetrics = _.throttle(this._feedTimeMetrics, oneSecond);
        var that = this;

        this.$feedPlaceholder.on('click', '.feed-post', function(ev) {
            throttledPostClickMetrics.call(that, ev.target);
        });

        this.$document.on('scroll', throttledPostViewMetrics.bind(this));

        setInterval(throttledFeedTimeMetrics.bind(this), oneSecond);

        this.$document.on('pageRendered', function() {
            that.$feedPosts = $.merge(
                that.$feedPosts,
                $('.bastian-page').last().children()
            );
        });

        this.$window.on('focus', function() {
            that.windowIsVisible = true;
        }).on('blur', function() {
            that.windowIsVisible = false;
        });
    };

    HorizonFeedMetrics.prototype.collectMetrics = function() {
        var requestHorizonTimeInterval = 10000;

        setInterval(this._doAjax.bind(this), requestHorizonTimeInterval);
    };

    HorizonFeedMetrics.prototype._doAjax = function() {
        if (this.data.length) {
            $.ajax(this.horizonUrl, {
                contentType: 'application/json',
                data: JSON.stringify(this.data),
                type: 'POST',
                xhrFields: {
                    withCredentials: true
                }
            });

            this.data = [];
        }
    };

    HorizonFeedMetrics.prototype._postClickMetrics = function(eventTarget) {
        var $post = this._getPostFromEventTarget(eventTarget);
        var data;

        this._updateCountFeedTime();
        data = this._getPostInfos($post, 'post-click');
        this.data.push(data.payload);
        this._doAjax();
    };

    HorizonFeedMetrics.prototype._postViewMetrics = function() {
        var that = this;
        var data;

        this.$feedPosts.each(function() {
            var $post = $(this);

            if ($post.visible(true)) {
                data = that._getPostInfos($post, 'post-view');

                if (data.finalPostPosition > that.lastPostViewedPosition) {
                    that.lastPostViewedPosition = data.finalPostPosition;
                    that.data.push(data.payload);
                }
            }
        });
    };

    HorizonFeedMetrics.prototype._getPostInfos = function($post, operation) {
        var postId = $post.data('post-id');
        var postType = $post.data('post-type');
        var finalPostPosition = this._getAbsolutePostPosition($post);
        var postHasResumo = this._hasPostResumo($post);
        var postUrl = $post.find('.feed-post-link').attr('href');
        var hasPhoto;
        var payload = {
            'product': this.product,
            'operation': operation,
            'object': window.location.href,
            'device_group': this.device_group,
            'attributes': {
                'post-id': postId,
                'post-type': postType,
                'post-position': finalPostPosition.toString(),
                'post-has-resumo': postHasResumo.toString(),
                'post-url': postUrl,
                'feed-view-ms': this.countFeedTime.toString(),
                'feed-type': this.feedType
            }
        };

        if (postType === 'materia') {
            hasPhoto = $post.find('.gui-image-full').length > 0 ? true : false;
            hasPhoto = hasPhoto.toString();
            payload['attributes']['post-has-photo'] = hasPhoto;
        } else if (postType === 'video') {
            delete payload['attributes']['post-has-resumo'];
        }

        return {
            payload: payload,
            finalPostPosition: finalPostPosition
        };
    };

    HorizonFeedMetrics.prototype._feedTimeMetrics = function() {
        if (this.windowIsVisible) {
            if (this.$window.height() + this.$document.scrollTop() > this.$titleFirstPost.offset().top) {
                if (!this.timeSeenFeed) {
                    this.timeSeenFeed = new Date().getTime() - 1;
                }
                this._updateCountFeedTime();
                this.timeSeenFeed = new Date().getTime();
            } else {
                this.timeSeenFeed = 0;
            }
        } else {
            this.timeSeenFeed = 0;
        }
    };

    HorizonFeedMetrics.prototype._updateCountFeedTime = function() {
        var now = new Date().getTime();

        this.countFeedTime = this.countFeedTime + (now - this.timeSeenFeed);
    };

    // ============================================================
    // ===================== GOOGLE ANALYTICS =====================
    // ============================================================

    var GoogleAnalyticsFeedMetrics = function() {
        FeedMetrics.call(this);

        this.currentPageNumber = 1;
        this.method = '_trackEvent';
        this.category = 'feed';
        this.action = 'post basico';
        window._gaq = window._gaq || [];

        return this;
    };

    GoogleAnalyticsFeedMetrics.prototype = Object.create(FeedMetrics.prototype);
    GoogleAnalyticsFeedMetrics.prototype.constructor = GoogleAnalyticsFeedMetrics;

    GoogleAnalyticsFeedMetrics.prototype.bindEvents = function() {
        var that = this;

        this.$feedPlaceholder.on('click', '.load-more', this._maisNoticiasButtonClick.bind(this));
        this.$feedPlaceholder.on('click', '.share-button', function(ev) {
            that._shareBarClickMetrics.call(that, ev);
        });
        this.$feedPlaceholder.on('click', '.feed-post', function(ev) {
            that._postClickMetricsAnalytics.call(that, ev.target);
        });
    };

    GoogleAnalyticsFeedMetrics.prototype._maisNoticiasButtonClick = function() {
        window._gaq.push([this.method, this.category, 'botao mais noticias', 'interacao | carregamento ' + this._getStrPosition(this.currentPageNumber)]);
        this.currentPageNumber += 1;
    };

    GoogleAnalyticsFeedMetrics.prototype._shareBarClickMetrics = function(event) {
        var eventTarget = event.target;
        var $eventTarget = $(eventTarget);
        var $post = this._getPostFromEventTarget(eventTarget);
        var finalPostPosition = this._getAbsolutePostPosition($post);
        var area;
        var midia;
        var resumo;
        var label;
        var $shareButton;

        if ($eventTarget.hasClass('share-button')) {
            $shareButton = $eventTarget;
        } else {
            $shareButton = $eventTarget.parents('.share-button');
        }

        if ($shareButton.hasClass('share-facebook')) {
            area = 'facebook';
        } else if ($shareButton.hasClass('share-twitter')) {
            area = 'twitter';
        } else if ($shareButton.hasClass('share-googleplus')) {
            area = 'google plus';
        } else if ($shareButton.hasClass('share-whatsapp')) {
            area = 'whatsapp';
        } else {
            area = '';
        }

        midia = this._getMidia($eventTarget);
        resumo = this._hasPostResumo($post) ? 'com resumo' : 'sem resumo';
        label = 'interacao | ' + area + ' | ' + midia + ' | ' + resumo + ' | posicao ' + this._getStrPosition(finalPostPosition);

        window._gaq.push([this.method, this.category, this.action, label]);
        event.stopPropagation();
    };

    GoogleAnalyticsFeedMetrics.prototype._postClickMetricsAnalytics = function(eventTarget) {
        var $eventTarget = $(eventTarget);
        var $post = this._getPostFromEventTarget(eventTarget);
        var finalPostPosition = this._getAbsolutePostPosition($post);
        var area;
        var label;
        var midia;
        var resumo;

        area = this._getAreaFromPost($eventTarget);
        midia = this._getMidia($eventTarget);
        resumo = this._hasPostResumo($post) ? 'com resumo' : 'sem resumo';
        label = 'clique | ' + area + ' | ' + midia + ' | ' + resumo + ' | posicao ' + this._getStrPosition(finalPostPosition);

        window._gaq.push([this.method, this.category, this.action, label]);
    };

    GoogleAnalyticsFeedMetrics.prototype._getStrPosition = function(positionNumber) {
        var strPositionNumber = positionNumber.toString();

        if (positionNumber < 10) strPositionNumber = '0' + strPositionNumber;

        return strPositionNumber;
    };

    GoogleAnalyticsFeedMetrics.prototype._getAreaFromPost = function($eventTarget) {
        var area = '';

        if ($eventTarget.hasClass('feed-post-header') || $eventTarget.parents('.feed-post-header').length) {
            area = 'chapeu';
        } else if ($eventTarget.hasClass('gui-image-full') || $eventTarget.parents('.gui-image-full').length) {
            area = 'midia';
        } else if ($eventTarget.hasClass('feed-post-body-title')) {
            area = 'titulo';
        } else if ($eventTarget.hasClass('feed-post-body-resumo')) {
            area = 'resumo';
        }

        return area;
    };

    GoogleAnalyticsFeedMetrics.prototype._getMidia = function($eventTarget) {
        var midiaContent = $eventTarget.parents('.feed-post').find('.gui-image-full');
        var midia;

        if (midiaContent.length) {
            midia = midiaContent.hasClass('gui-video-full') ? 'com video' : 'com foto';
        } else {
            midia = 'sem midia';
        }

        return midia;
    };

    // ============================================================
    // =========================== INIT ===========================
    // ============================================================

    $(document).ready(function() {
        var settings = window.SETTINGS || {};
        var bastianSettings = settings.BASTIAN || {};
        var horizonHost = bastianSettings.HORIZON_HOST;
        var portal = bastianSettings.PORTAL;
        var horizonFeedMetrics;
        var googleAnalyticsFeedMetrics;

        googleAnalyticsFeedMetrics = new GoogleAnalyticsFeedMetrics();
        googleAnalyticsFeedMetrics.bindEvents();

        if (!horizonHost || !portal) {
            console.warn('You need to properly configure the settings "PORTAL" AND "HORIZON_HOST" on your product.');
            return;
        }
        horizonFeedMetrics = new HorizonFeedMetrics(horizonHost, portal);

        horizonFeedMetrics.bindEvents();
        horizonFeedMetrics.collectMetrics();
    });
})();
